import { useQuery } from '@apollo/client'
import { IconCheckbox } from '@tabler/icons-react'

import {
  CommandModule,
  DEFAULT_CHECKLIST_ACTIONS,
  DynamicActionsProps,
} from './config'

import { useProject } from '@/context/projectContext'
import { GET_TEMPLATES_LIST } from '@/modules/templates/graphQL'
import { routes } from '@/utils/index'

import {
  TemplateType,
  TemplatesListUiQuery,
  TemplatesListUiQueryVariables,
} from 'types/api.graphql'

export const DynamicChecklistActions: React.FC<DynamicActionsProps> = ({
  activePage,
  debouncedSearchText,
  replaceParentSubItems,
}) => {
  const { project, isProjectSelected } = useProject()

  useQuery<TemplatesListUiQuery, TemplatesListUiQueryVariables>(
    GET_TEMPLATES_LIST,
    {
      variables: {
        filter: {
          searchString: debouncedSearchText,
          templateResponseProjectId: isProjectSelected
            ? project?.id
            : undefined,
          templateType: TemplateType.Inspection,
        },
      },
      skip:
        activePage !== CommandModule.Checklists || !debouncedSearchText?.length,
      onCompleted: (data) => {
        replaceParentSubItems(CommandModule.Checklists, [
          ...DEFAULT_CHECKLIST_ACTIONS,
          ...(data?.templates?.map((checklist) => ({
            id: checklist.id,
            name: checklist.templateName,
            icon: IconCheckbox,
            href: routes.checklistsChecklists.checklistsOfTemplateList(
              checklist.id
            ),
          })) ?? []),
        ])
      },
    }
  )

  return null
}
